import React, { Component } from 'react';
import { Card, Tabs, Divider, Row, Col } from 'antd';
import TableView from './TableView';

class Viewer extends Component {
  static defaultProps = {
    type: 'tabs', /* tabs, cards, tables */
    columns: 1,
  }

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  renderRowCards = () => {
    const { fieldItemsGroups, columns } = this.props;

    let cols;
    const rows = [];
    for (let i = 0, count = fieldItemsGroups.length; i < count; i += columns) {
      cols = [];
      for (let j = 0; j < columns; j++) {
        if (count > i + j) {
          cols.push({ key: `col__${new Date().getTime()}`, group: fieldItemsGroups[i + j] });
        }
      }

      rows.push({ key: `row__${new Date().getTime()}`, cols });
    }
    return (
      rows.map(r => (
        <Row key={r.key}>
          {r.cols.map(c => (
            <Col key={c.key}>
              {this.renderCard(c.group)}
            </Col>
          ))}
        </Row>
      ))
    );
  }

  renderCard = (group) => (
    <Card key={`${this.props.entityId}-${group.id}`}>
      {group.displayName && <Divider orientation="left">{group.name}</Divider>}
      <TableView data={this.props.fieldItems ? this.props.fieldItems : []} onActionRender={this.props.onActionRender} />
    </Card>
  )

  renderTables = (group) => {
    return (
      <div key={`${this.props.entityId}-${group.id}`}>
        {group.displayName && <Divider orientation="left">{group.name}</Divider>}
        {!group.displayName && <br />}
        <TableView fieldItems={group.fieldItems} rowKey="fieldDefinitionId" onActionRender={this.props.onActionRender} />
      </div>
    );
  }

  renderTabs = (group) => {
    return (
      <Tabs.TabPane key={`${this.props.entityId}-${group.id}`} tab={group.name}>
        <TableView fieldItems={group.fieldItems} rowKey="fieldDefinitionId" onActionRender={this.props.onActionRender} />
      </Tabs.TabPane>
    );
  }

  render() {
    const { type, fieldItemGroups } = this.props;

    if (!fieldItemGroups || fieldItemGroups.length === 0) {
      return null;
    }

    if (type === 'tabs') {
      return (
        <Tabs defaultActiveKey={`${this.props.entityId}-${fieldItemGroups[0].id}`}>
          {fieldItemGroups.map(this.renderTabs)}
        </Tabs>
      );
    }
    if (type === 'tables') {
      return (
        <div>
          {fieldItemGroups.map(this.renderTables)}
        </div>
      );
    }
    if (type === 'cards') {
      return (
        <div>
          {this.renderRowCards()}
        </div>
      );
    }
    return null;
  }
}

export default Viewer;
